export default "__VITE_ASSET__hP$KfC5___"